export const LS_USE_ANIMATIONS_KEY = '__use-animations';
export const LS_LANG_KEY = '__lang';
export const LS_INTERCOM_TOUR_KEY = '__ayn-intercom-states';
